<script>
    export let tags = []; // {id, value}
    export let allowAdd = true;
    export let minTags = 0; // minimum number of tags required
    export let highlightFirstTag = false;
    export let dragDisabled = false;

    $: canDelete = tags.length > minTags;

    import { createEventDispatcher, onMount } from "svelte";
    import { flip } from "svelte/animate";
    import { dndzone } from "svelte-dnd-action";
    import { nextId } from "./id_generator.js";

    const dispatch = createEventDispatcher();

    let tag = "";
    let isInputing = false;
    const ENTER = 13;
    const BACKSPACE = 8;
    const flipDurationMs = 300;
    function updateTag(newTags) {
        tags = newTags;
        dispatch("tags", { tags });
    }

    function addTag(tag) {
        tag = tag.trim();
        if (tag === "") return;
        const newList = [...tags, { id: nextId(), value: tag }];
        updateTag(newList);
    }
    function setTag(input) {
        const currentTag = input.target.value;
        if (ENTER === input.keyCode) {
            if (currentTag) input.preventDefault();
            addTag(currentTag);
            tag = "";
        } else if (BACKSPACE === input.keyCode && tag === "") {
            if (canDelete) {
                tags.pop();
                updateTag(tags);
            }
        }
    }
    function onBlur() {
        if (tag.trim() !== "") {
            addTag(tag);
            tag = "";
        }
        if (!dragDisabled) {
            isInputing = false;
        }
    }
    function removeTag(index) {
        if (canDelete) {
            tags.splice(index, 1);
            updateTag(tags);
        }
    }
    function handleDndConsider(e) {
        tags = e.detail.items;
    }
    function handleDndFinalize(e) {
        tags = e.detail.items;
        dispatch("tags", { tags });
    }
    onMount(() => {
        if (allowAdd && tags.length === 0) {
            isInputing = true;
        }
    });
</script>

<div
    class="tags-container"
    use:dndzone={{
        items: tags,
        flipDurationMs,
        dragDisabled,
        dropTargetStyle: "",
    }}
    on:consider={handleDndConsider}
    on:finalize={handleDndFinalize}
    on:mouseup={() => (isInputing = true)}
    class:tags-container-allowAdd={allowAdd}
>
    {#each tags as tag, index (tag.id)}
        <span
            class="tag"
            class:non-first={highlightFirstTag && index > 0}
            animate:flip={{ duration: flipDurationMs }}
        >
            {tag.value}
            <span
                class="tag-remove"
                class:tag-remove-disabled={!canDelete}
                on:click={() => removeTag(index)}>&nbsp;&#215;</span
            >
        </span>
    {/each}
    {#if allowAdd && isInputing}
        <input
            type="text"
            class="input"
            on:keydown={setTag}
            bind:value={tag}
            on:blur={onBlur}
            autofocus
        />
    {/if}
</div>

<style>
    .tags-container {
        background-color: #d1e4fc;
        display: flex;
        align-items: center;
        padding: 0px 5px 5px 5px;
        border: solid 1px #ccc;
        border-radius: 2px;
        flex-wrap: wrap;
        min-height: 2.6em;
    }
    .tags-container-allowAdd {
        cursor: text;
    }

    .tags-container:focus,
    .tags-container:hover {
        border: solid 1px #000;
    }

    .input {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin: 0;
        margin-top: 5px;
        border: none;
        background-color: #d1e4fc;
    }
    .input:focus {
        outline: 0;
    }

    .tag {
        display: flex;
        white-space: nowrap;
        list-style: none;
        background: #3479f6;
        color: #fff;
        border-radius: 4px;
        margin-right: 5px;
        margin-top: 5px;
        padding: 2px 5px;
    }

    .tag-remove {
        cursor: pointer;
    }

    .tag-remove-disabled {
        cursor: not-allowed;
    }
    .non-first {
        background: #6499dc;
    }
</style>
